import { useCallback, memo } from 'react';
import { useFormattedCurrencyDisplay } from '../v2/hooks/useFormattedCurrencyDisplay';
import UICurrencyInput from 'UIComponents/input/UICurrencyInput';
import UINumberInput from 'UIComponents/input/UINumberInput';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputHomeCurrencyV2 = props => {
  const {
    onChange,
    inputRef,
    multiCurrencyCurrencyCode,
    min: minFromProps
  } = props;
  const {
    currencyValue,
    currencyCode,
    formattingOptions: {
      min,
      fractionalCurrencyProps
    }
  } = useFormattedCurrencyDisplay({
    defaultCurrencyCode: multiCurrencyCurrencyCode,
    defaultMin: minFromProps
  });
  const handleChange = useCallback(evt => {
    if (typeof onChange === 'function') {
      // UINumberInput and UICurrencyInput's onChange send `number | null`; convert to `string | null`
      onChange(evt.target.value == null ? evt : SyntheticEvent(String(evt.target.value)));
    }
  }, [onChange]);
  return !currencyCode ? /*#__PURE__*/_jsx(UINumberInput, Object.assign({}, getTransferrableProps(props), {
    onChange: handleChange,
    inputRef: inputRef
    // @ts-expect-error UINumberInput propTypes allow 'null', but TS types do not; see https://git.hubteam.com/HubSpot/UIComponents/issues/10822
    ,
    value: currencyValue
  })) : /*#__PURE__*/_jsx(UICurrencyInput, Object.assign({}, getTransferrableProps(props), fractionalCurrencyProps, {
    isNativeCurrency: false,
    currency: currencyCode,
    onChange: handleChange,
    inputRef: inputRef
    // @ts-expect-error UICurrencyInput propTypes allow 'null', but TS types do not; see https://git.hubteam.com/HubSpot/UIComponents/issues/10822
    ,
    value: currencyValue,
    min: min
  }));
};
export default /*#__PURE__*/memo(PropertyInputHomeCurrencyV2);